import { GlobalConstants } from "../../data/GlobalConstants";
import { handleResponse } from "../../util/functions";
import { getToken } from "../../helpers/helperJWT";
import { loaderService } from "../loaderService";

const url = GlobalConstants.urlApi;

const getBanners = (data) => {
    loaderService.showLoader({ label: "Cargando..." });

    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/banners/getBanners`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const deleteBanner = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/banners/deleteBanner`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveBanner = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/banners/saveBanner`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const updateBanner = (data) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': getToken()
        },
        body: JSON.stringify(data)
    };

    return fetch(`${url}/unoauno/banners/updateBanner`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

const saveImagen = ({file, idBanner, extension, nombreImg}) => {
    const formData = new FormData();

    formData.append('id', idBanner.toString());
    formData.append('extension', extension);
    formData.append('nombreImg', nombreImg);
    formData.append('img', file);

    const requestOptions = {
        method: 'POST',
        headers: {
            'Authorization': getToken()
        },
        body: formData
    };

    return fetch(`${url}/unoauno/banners/saveImagen`, requestOptions)
        .then(handleResponse)
        .then(response => {
            return response;
        });
}

export const bannersService = {
    getBanners,
    deleteBanner,
    saveBanner,
    updateBanner,
    saveImagen
};